import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '@hooks/statehooks';
import { updateAllParams } from '../store/reducers/vehiclesearchparams';
import { CalculationSearchParams } from 'interface';

export const useVehicleSearchParams = () => {
  let [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  const vehicleSearchParams = useMemo(() => {
    let params = Object.fromEntries([...searchParams]);

    const getCalculationParameters = () => {
      const calculationParameters = params.calculationParameters
        ? params.calculationParameters.split(',').map((item) => item.split('='))
        : [];

      let parseData = {};

      for (let index = 0; index <= calculationParameters.length - 1; index++) {
        parseData = {
          ...(parseData as object),
          ...{
            [calculationParameters[index][0].toString()]:
              calculationParameters[index][1],
          },
        };
      }

      return parseData as CalculationSearchParams;
    };

    const getSearchParams = () => {
      const vehicleId = params.id;
      const optionsSelected = searchParams.get('optionsSelected');
      const optionsAdded = searchParams.get('optionsAdded');
      const calcParams = getCalculationParameters();

      // Workaround as include_maintenance comes through as a string
      const maintenanceConversion: boolean =
        (calcParams.include_maintenance &&
          (calcParams.include_maintenance.toString() === 'true' ||
            calcParams.include_maintenance.toString() === 'Y')) ??
        false;

      const optionsSelectedArray = optionsSelected
        ?.split(',')
        .map((element) => {
          return Number(element);
        });

      dispatch(
        updateAllParams({
          id: Number(vehicleId),
          duration: Number(calcParams.duration),
          include_maintenance: maintenanceConversion,
          yearly_mileage: Number(calcParams.yearly_mileage),
          initial_payment: Number(calcParams.initial_payment),
          optionsSelected: optionsSelected ? optionsSelectedArray : [],
          optionsAdded: optionsAdded ? Number(optionsAdded) : null,
        })
      );

      return {
        id: Number(vehicleId),
        duration: Number(calcParams.duration),
        include_maintenance: maintenanceConversion,
        yearly_mileage: Number(calcParams.yearly_mileage),
        initial_payment: Number(calcParams.initial_payment),
        optionsSelected: optionsSelected ? optionsSelectedArray : null,
        optionsAdded: optionsAdded ? Number(optionsAdded) : null,
      };
    };
    return getSearchParams();
  }, [searchParams]);

  return { vehicleSearchParams };
};
